import React, { useState } from 'react';
import './Home.css';
import Notification from './Notification';

function WHONaturopathicWorkforce() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>

          <div className="topbar-marquee-group">
            <Notification />
            <Notification
              variant="danger"
              messages={[
                'State registration is mandatory as part of the NRB-HPR integrated registration process. Kindly download the HPR Certificate and I-card from HPR Portal through this link https://nhpr.abdm.gov.in/nhpr/v4/login'
              ]}
            />
          </div>
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* Content */}
      <div style={{
        minHeight: '70vh',
        padding: '60px 20px',
        background: '#ffffff'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '20px',
            color: '#2c3e50'
          }}>WHO Region Wise Listing of Countries with Naturopathic Workforce 2023</h1>

          <p style={{
            textAlign: 'center',
            color: '#666',
            marginBottom: '40px',
            fontSize: '1.1rem'
          }}>
            Global distribution of naturopathic workforce across WHO regions
          </p>

          {/* Map Section */}
          <div style={{
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            height: '650px',
            width: '100%',
            marginBottom: '40px'
          }}>
            <iframe
              title="WHO Global Naturopathic Workforce Distribution"
              src="https://www.google.com/maps/d/embed?mid=1aWlefeVNszQ9nF7HI3N7sbSUhY06VII&ehbc=2E312F"
              width="100%"
              height="100%"
              style={{
                border: 'none'
              }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* WHO Information Section */}
          <div style={{
            background: '#f8fafc',
            padding: '30px',
            borderRadius: '12px',
            marginTop: '30px'
          }}>
            <h2 style={{
              fontSize: '1.8rem',
              marginBottom: '20px',
              color: '#2c3e50'
            }}>WHO Regional Distribution</h2>
            
            <p style={{
              color: '#666',
              lineHeight: '1.8',
              marginBottom: '20px'
            }}>
              The World Health Organization recognizes naturopathy as an important component of traditional and complementary medicine. 
              This map displays countries across different WHO regions where naturopathic practitioners are actively working 
              to provide healthcare services.
            </p>

            <div style={{
              marginTop: '30px',
              padding: '20px',
              background: '#e0f2fe',
              borderRadius: '8px',
              borderLeft: '4px solid #2563eb'
            }}>
              <h3 style={{ color: '#1e40af', marginBottom: '10px' }}>📊 Global Recognition</h3>
              <p style={{ color: '#075985', fontSize: '0.95rem', lineHeight: '1.6' }}>
                The naturopathic workforce continues to grow globally, with increasing recognition by health authorities 
                and integration into national healthcare systems. This map reflects data from the WHO's 2023 report on 
                traditional and complementary medicine workforce.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default WHONaturopathicWorkforce;


